<template>
    <el-badge :value="unreadCount" class="noticeCount cursor-pointer" :class="{'hasNotice':unreadCount>0 }" @click="showNotification">
        <el-icon class="notice"><bell /></el-icon>
    </el-badge>

    <el-drawer append-to-body
        class ="notificationDrawer"
        size="90%" 
        direction="btt"
        v-model="noticeVisibleState">
        <template #header>
            <h3 style="text-align: center;">消息中心</h3>
        </template>
        <div class="notification-body">
            <notification-panel :notifications="notifications"></notification-panel>
        </div>
    </el-drawer>
</template>

<style>
    :root{
        --notice-line-height:20px;
    }

    .noticeCount{
        line-height: var(--notice-line-height);
        margin-right: 20px;
        height: var(--notice-line-height);
    }
    
    .notice{
        font-size: var(--notice-line-height);
        height: var(--notice-line-height);
        width: var(--notice-line-height);
    }

    .notificationDrawer>.el-drawer__header{
        padding-top: 0;
        margin-bottom:0px;
        border-bottom:1px solid #ebecee;
    }

    .notificationDrawer>.el-drawer__header h3{
        text-align: center;
        color: black;
        font-weight: 500;
    }

    .notificationDrawer>.el-drawer__body{
        background-color: rgb(245, 246, 248);
    }

    .notification-body{
        width: 60%;
        margin-left: 20%;
        height: 100%;
    }

    sup.el-badge__content.el-badge__content--danger.is-fixed{
        display: none;
    }

    .hasNotice sup.el-badge__content.el-badge__content--danger.is-fixed{
        display: block;
    }
</style>

<script>
    import notificationPanel from "./NotificationPanel.vue"
    import { Bell } from '@element-plus/icons-vue'
    import { getNotifications } from "../../apis/httpHelper"
    import listener from "./NotificationListener"
    import { qweIsEmpty } from "../../common/commonHelper"
    import { initSignalR, addReceiveMessageTask } from "../../utils/signalR/SignalR"

    export default {
        mixins:[listener],

        data:function(){
            return {
                noticeCount:0,
                noticeVisibleState:false,
                notifications:[]
            }
        },

        created:function(){
            let self = this;

            initSignalR();
            
            addReceiveMessageTask((response)=>{
                self.$store.commit("setNotificationMessage", response);
                self.initNotification();
            })
            
            this.initNotification();
        },

        components:{
            'bell':Bell,
            'notification-panel': notificationPanel
        },

        computed:{
            unreadCount:function(){
                return this.notifications.filter(x=> !x.Read).length;
            },

            showNotifications:function(){
                if(!qweIsEmpty(this.filterValue)){
                    return this.notifications.filter(x=>x.Read == (this.filterValue == "true"));
                }
                else{
                    return this.notifications
                }
            }
        },

        methods:{
            initNotification:async function(){
                let response = await getNotifications();
                response.Result.forEach(x=> x.ShowToDo = !qweIsEmpty(x.ToDo))
                this.notifications = response.Result;
            },

            showNotification:function(){
                this.noticeVisibleState = true;
            }
        }
    }
</script>